// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"7908": "41e483a4","8710": "6f5ad369","9604": "4fb59da1",}[chunkId] + ".css"
}